import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { platformName } from '../../../platformMeta';
import type { SocialPlatform } from '../../../types';
import { PlanChannelChips } from '../PlanChannelChips';
import { ChannelMark } from '../rollout/ChannelMark';
import { reelsPlanMessages } from './reelsPlanMessages';
/* eslint-disable css-modules/no-unused-class -- each part uses its own slice of the two stylesheets */
import rolloutStyles from '../rollout/Rollout.module.scss';
import styles from './ReelsPlan.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelsPlanChannelsRowProps {
  /** The usable channels that take a reel. */
  platforms: SocialPlatform[];
  selected: SocialPlatform[];
  disabled: boolean;
  onToggle: (platform: SocialPlatform) => void;
}

/**
 * "Channels" of the setup (design rollout-plan f1): the marks and the names of the channels of the
 * plan. "Change channels" opens the chip picker of the plan (`PlanChannelChips`) under the row.
 */
const ReelsPlanChannelsRowComponent: React.FC<ReelsPlanChannelsRowProps> = ({
  platforms,
  selected,
  disabled,
  onToggle,
}) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = useCallback(() => setIsOpen((open) => !open), []);

  return (
    <>
      <div className={styles.seg}>
        <span className={rolloutStyles.chns}>
          {selected.map((platform) => (
            <ChannelMark key={platform} platform={platform} small />
          ))}
        </span>
        <span className={styles.names}>{selected.map((platform) => platformName(platform)).join(', ')}</span>
        <button
          type="button"
          className={rolloutStyles.link}
          disabled={disabled}
          aria-expanded={isOpen}
          onClick={toggleOpen}
        >
          {intl.formatMessage(isOpen ? reelsPlanMessages.channelsDone : reelsPlanMessages.changeChannels)}
        </button>
      </div>
      {isOpen && !disabled && (
        <div className={styles.chips}>
          <PlanChannelChips platforms={platforms} selected={selected} onToggle={onToggle} />
        </div>
      )}
    </>
  );
};

export const ReelsPlanChannelsRow = TypedMemo(ReelsPlanChannelsRowComponent);
